import { getQueryString } from './query-string';

interface IRequestInit extends RequestInit {
    params?: {
        [key: string]: number | string | undefined | null;
    };
}

const fetchData = <T = any>(url: RequestInfo, { params, ...init }: IRequestInit = {}, isText?: boolean): Promise<T> =>
    fetch(url + (params ? '?' + getQueryString(params) : ''), init).then(function handleResponse(res) {
        if (res.ok) {
            if (isText) {
                return res.text();
            }
            return res.json();
        }
        return Promise.reject(
            new Error(
                'ajax error: ' + url + (params ? '?' + getQueryString(params) : '') + '. Response: ' + res.statusText
            )
        );
    });

const postData = <T = any>(url: RequestInfo, method: 'POST' | 'PUT', data: any, init: IRequestInit = {}): Promise<T> =>
    fetchData(url, {
        method: method,
        body: JSON.stringify(data),
        ...init
    });

export const get = fetchData;

export const getText = <T = any>(url: RequestInfo): Promise<T> => fetchData(url, {}, true);

export const post = <T = any>(url: RequestInfo, data: any, init: IRequestInit = {}): Promise<T> =>
    postData(url, 'POST', data, init);

export const put = <T = any>(url: RequestInfo, data: any, init?: IRequestInit): Promise<T> =>
    postData(url, 'PUT', data, init);
